import React from "react";
import Navbar from "../../components/landingPageComponent/Navbar";
import AboutUs from "../../components/landingPageComponent/AboutLink";
import Footer from "../../components/landingPageComponent/Footer";
import Mission from "../../components/landingPageComponent/Misson";
import ScrollTop from "../../components/landingPageComponent/ScrollTop";
import CoreBusinessValues from "../../components/landingPageComponent/CoreBusinessValues";

const About = () => {
  return (
    <div className="overflow-hidden">
      <Navbar />
      <AboutUs />
      <Mission />
      <CoreBusinessValues />
      <Footer />
      <ScrollTop />
    </div>
  );
};

export default About;
